"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VariantId = (function () {
    function VariantId(id) {
        this.id = id;
        if (id < 0) {
            throw new RangeError("Unable to construct Id: value must be greater than or equal to zero (Given: " + id + ")");
        }
        this.id = id;
    }
    VariantId.prototype.toJSON = function () {
        return this.id;
    };
    return VariantId;
}());
exports.VariantId = VariantId;
//# sourceMappingURL=VariantId.js.map